import React from "react";
import Certificado from "../../pages/certificado/Certificado";
import CertificadoVencer from "../../pages/certificadoVencer/CertificadoVencer";

const prefix = process.env.REACT_APP_PREFIX;

const certificadoDigitalRoutes = [
  {
    path: `${prefix}/GestaoEmpresa/Certificado/`,
    component: <Certificado />,
    title: "certificado digital",
  },
  {
    path: `${prefix}/gerencial/CertificadoVencer/`,
    component: <CertificadoVencer />,
    title: "Certificados a vencer",
  },
];

export default certificadoDigitalRoutes;
